export var stripPTag = function (taggedString) {
    return taggedString
        ? taggedString.replaceAll('<p>', '').replaceAll('</p>', '')
        : '';
};
export var getColourByAlertSeverity = function (type) {
    switch (type) {
        case 'error':
            return 'errorMain';
        case 'warning':
            return 'alertMain';
        case 'success':
            return 'successMain';
        case 'none':
        default:
            return 'textLight';
    }
};
export var getShapeClassByAlertSeverity = function (type) {
    switch (type) {
        case 'error':
            return 'h-2.5 w-2.5 bg-errorMain';
        case 'warning':
            return 'h-0 w-0 border-opacity-0 border-t-0 border-l-5 border-l-transparent border-r-5 border-r-transparent border-b-10 border-b-alertMain shadow-none';
        case 'success':
            return 'h-2.5 w-2.5 rounded-full bg-successMain';
        default:
            return 'h-2.5 w-2.5 rounded-full bg-successMain';
    }
};
//# sourceMappingURL=typography.util.js.map